document.addEventListener("DOMContentLoaded", function () {
  var menuTrigger = document.querySelector(".mobile-menu__trigger");
  var menuClose = document.querySelector(".mobile-menu__close");
  var mobileMenu = document.querySelector(".mobile-menu");

  if (menuTrigger && menuClose && mobileMenu) {
    menuTrigger.addEventListener("click", function () {
      mobileMenu.classList.add("active");
    });

    menuClose.addEventListener("click", function () {
      mobileMenu.classList.remove("active");
    });
  }

  var menuLinks = document.querySelectorAll(".top-main-menu li a");

  // Dodaj zdarzenie kliknięcia dla każdego linku
  menuLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      // Znajdź aktualnie aktywny element menu
      var currentActive = document.querySelector(
        ".top-main-menu li.current-menu-item"
      );

      // Usuń klasę 'current-menu-item' z aktualnie aktywnego elementu, jeśli istnieje
      if (currentActive) {
        currentActive.classList.remove("current-menu-item");
      }

      // Dodaj klasę 'current-menu-item' do klikniętego elementu 'li'
      event.currentTarget.parentElement.classList.add("current-menu-item");
    });
  });
  /*
  var menu = document.querySelector(".top-main-menu");
  var menuLinks = menu.querySelectorAll("li a");

  menu.addEventListener("click", function (event) {
    if (event.target && event.target.tagName === "A") {
      var clickedLink = event.target;

      // Znajdź aktualnie aktywny element menu
      var currentActive = menu.querySelector("li.current-menu-item");

      // Jeśli kliknięty link jest już aktywny, nic nie rób
      if (currentActive === clickedLink.parentElement) {
        return;
      }

      // Usuń klasę 'current-menu-item' z aktualnie aktywnego elementu, jeśli istnieje
      if (currentActive) {
        currentActive.classList.remove("current-menu-item");
      }

      // Dodaj klasę 'current-menu-item' do klikniętego elementu 'li'
      clickedLink.parentElement.classList.add("current-menu-item");
    }
  });*/
});
/*
document.addEventListener("DOMContentLoaded", function () {
  let menu = document.querySelector(".top-main-menu");

  if (menu) {
    let currentMenuItem = menu.querySelector("li.current-menu-item");

    // Jeśli istnieje element z klasą "current-menu-item"
    if (currentMenuItem) {
      // Usuń klasę "current_page_parent" z wszystkich elementów "li" w menu
      let currentPageParents = menu.querySelectorAll("li.current_page_parent");
      currentPageParents.forEach(function (li) {
        li.classList.remove("current_page_parent");
      });
    }
  }
});*/
